import React from "react"
import { Global, css } from "@emotion/core"

const GlobalStyles = () => (
  <Global
    styles={css`
      body {
        overflow: visible !important;
        width: 100%;
      }
      picture,
      .gatsby-image-wrapper {
        margin-bottom: 1.6rem;
      }
    `}
  />
)

export default GlobalStyles
